/**
 * LanguageCard - Settings > Appearance language picker (F5 Phase 1).
 *
 * Shows NATIVE language names only (English / 日本語 / ไทย) - readable by the
 * person who needs them regardless of the current UI language. Switching is
 * instant (no reload), per-device (localStorage, like themes), and never
 * touches finance data or sync (LANGUAGE_NJCASH.md law).
 *
 * Reuses the font-size-presets button styling from SettingsPage.css so it
 * matches the Text Size card exactly.
 */

import { Card, CardHeader } from '@/components/shared';
import { useLanguage } from '@/i18n';

export function LanguageCard() {
  const { t, language, languages, setLanguage } = useLanguage();

  return (
    <Card className="language-card">
      <CardHeader
        title={t('settings.language.title')}
        subtitle={t('settings.language.help')}
      />
      <div className="font-size-presets" role="radiogroup" aria-label={t('settings.language.title')}>
        {languages.map((lang) => (
          <button
            key={lang.code}
            role="radio"
            aria-checked={language === lang.code}
            className={`preset-btn ${language === lang.code ? 'active' : ''}`}
            onClick={() => setLanguage(lang.code)}
          >
            {lang.nativeName}
          </button>
        ))}
      </div>
    </Card>
  );
}
